import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { GiftToneRequest } from '../api/tune/gifttune/gifttonerequest';
import { GiftToneResponse, GiftToneResponseDtoImpl } from '../api/tune/gifttune/gifttoneresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class GiftToneAPIProcessorImpl extends SixdeeCRBTAPIProcessor<GiftToneRequest, GiftToneResponse>
{
    execute(request: GiftToneRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new GiftToneResponseDtoImpl(APIFeatures.GIFT_TONE, "Gift Tone Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new GiftToneResponseDtoImpl(APIFeatures.GIFT_TONE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
      
            this.getAPIFailure(new GiftToneResponseDtoImpl(APIFeatures.GIFT_TONE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/gifttoneapiprocessor.tsx